<itl-wizard-page
  [pageTitleTransPath]="'Patienten auswählen'"
  [isSinglePage]="true"
  (doneClicked)="done()"
  (cancelClicked)="cancel()"
>
  <itl-search-filter-bar
    (searchValueReset)="reset()"
    (searchValueChanged)="search($event)"
    [showFilter]="false"
    [instantSearch]="true"
  ></itl-search-filter-bar>
  <itl-warning-item *ngIf="selectedItems.length === 0 && hasSearched"
    >{{ 'appointment.edit.noPatientsMessage' | translate }}
  </itl-warning-item>
  <div class="chips-wrapper">
    <ng-container *ngIf="!allSelected">
      <itl-chip
        *ngFor="let patient of selectedPatients"
        (chipClicked)="dismissSelection(patient)"
        (dismissClicked)="dismissSelection(patient)"
        >{{ patient.firstName }} {{ patient.lastName }}</itl-chip
      >
    </ng-container>
  </div>
  <div class="select-all-wrapper" (clicked)="toggleAllChecked()" *ngIf="selectedItems.length > 1">
    <!-- Div is nessary that checkbox is not directly clicked -->
    <div (click)="toggleAllChecked($event)" class="checkbox-wrapper">
      <ion-checkbox color="secondary-variant-alberta" [ngModel]="allSelected"></ion-checkbox>
      <span>{{ toggleCheckboxText }}</span>
    </div>
  </div>
  <div class="patient-list-wrapper">
    <itl-listitem *ngFor="let item of selectedItems" [paddingLeft]="'20px'" (clicked)="selectionChanged(item)">
      <itl-listitem-icon>
        <ion-checkbox [ngModel]="item.selected" color="secondary-variant-alberta"></ion-checkbox>
      </itl-listitem-icon>
      <itl-listitem-additional-info>
        <span class="bold">{{ item.patient.firstName }} {{ item.patient.lastName }} </span>
        {{ item.patient?.additionalAddress2 }}
      </itl-listitem-additional-info>
    </itl-listitem>
  </div>
</itl-wizard-page>
